import React, { useMemo } from 'react';
import SearchIcon from '@atlaskit/icon/core/migration/search';
import { COMMAND_PALETTE_SECTIONS } from '@atlassian/jira-command-palette-common/src/common/constants.tsx';
import {
	type Command,
	CommandActionType,
} from '@atlassian/jira-command-palette/src/common/types/commands/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { useIntl } from '@atlassian/jira-intl';
import { QUICK_SEARCH_ID } from './constants.tsx';
import { messages } from './messages.tsx';
import { useFireQuickSearchAnalyticsOnClose } from './use-fire-quick-search-analytics-on-close/index.tsx';
import { QuickSearchChildren } from './use-quick-search-children/index.tsx';
import { QuickSearchChildWrapper } from './use-quick-search-children/wrapper/index.tsx';

export const useQuickSearchCommand = (props?: { keepSearch?: boolean }) => {
	const keepSearch = props?.keepSearch;
	const { formatMessage } = useIntl();

	useFireQuickSearchAnalyticsOnClose();
	const quickSearchCommand = useMemo(
		(): Command => ({
			id: QUICK_SEARCH_ID,
			name: formatMessage(
				fg('jira-issue-terminology-refresh-m3')
					? messages.searchCommandNameIssueTermRefresh
					: messages.searchCommandName,
			),
			placeholder: formatMessage(
				fg('jira-issue-terminology-refresh-m3')
					? messages.searchInputPlaceHolderIssueTermRefresh
					: messages.searchInputPlaceHolder,
			),
			keywords: formatMessage(messages.searchYourIssuesSynonyms),
			components: {
				LeftIcon: () => <SearchIcon spacing="spacious" label="" />,
			},
			mode: '/',
			section: COMMAND_PALETTE_SECTIONS.quickSearch,
			priority: 1,
			analytics: {
				action: 'quickSearchMode',
				actionCategory: 'quick-search',
			},
			primaryAction: {
				type: CommandActionType.COMMAND_LIST,
				components: {
					Body: QuickSearchChildren,
					Wrapper: QuickSearchChildWrapper,
				},
				keepSearch,
			},
		}),
		[formatMessage, keepSearch],
	);

	return { quickSearchCommand };
};
